import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

interface FilterOptions {
  bodyTypes: string[];
  transmissions: string[];
  fuelTypes: string[];
  exteriorColors: string[];
  interiorColors: string[];
  driveTypes: string[];
}

interface Filters {
  bodyType: string;
  transmission: string;
  fuelType: string;
  exteriorColor: string;
  interiorColor: string;
  driveType: string;
  isCertified: string;
}

interface CarFiltersProps {
  filters: Filters;
  filterOptions: FilterOptions;
  onFilterChange: (event: any) => void;
}

const CarFilters = ({
  filters,
  filterOptions,
  onFilterChange,
}: CarFiltersProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        '& .MuiSelect-select': {
          backgroundColor: 'white',
        },
      }}
    >
      {filterOptions.bodyTypes.length > 1 && (
        <FormControl fullWidth size="small">
          <InputLabel>Body Type</InputLabel>
          <Select
            name="bodyType"
            value={filters.bodyType}
            label="Body Type"
            onChange={onFilterChange}
          >
            <MenuItem value="">Any</MenuItem>
            {filterOptions.bodyTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {filterOptions.transmissions.length > 1 && (
        <FormControl fullWidth size="small">
          <InputLabel>Transmission</InputLabel>
          <Select
            name="transmission"
            value={filters.transmission}
            label="Transmission"
            onChange={onFilterChange}
          >
            <MenuItem value="">Any</MenuItem>
            {filterOptions.transmissions.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {filterOptions.fuelTypes.length > 1 && (
        <FormControl fullWidth size="small">
          <InputLabel>Fuel Type</InputLabel>
          <Select
            name="fuelType"
            value={filters.fuelType}
            label="Fuel Type"
            onChange={onFilterChange}
          >
            <MenuItem value="">Any</MenuItem>
            {filterOptions.fuelTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {filterOptions.driveTypes.length > 1 && (
        <FormControl fullWidth size="small">
          <InputLabel>Drive Type</InputLabel>
          <Select
            name="driveType"
            value={filters.driveType}
            label="Drive Type"
            onChange={onFilterChange}
          >
            <MenuItem value="">Any</MenuItem>
            {filterOptions.driveTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {filterOptions.exteriorColors.length > 1 && (
        <FormControl fullWidth size="small">
          <InputLabel>Exterior Color</InputLabel>
          <Select
            name="exteriorColor"
            value={filters.exteriorColor}
            label="Exterior Color"
            onChange={onFilterChange}
          >
            <MenuItem value="">Any</MenuItem>
            {filterOptions.exteriorColors.map((color) => (
              <MenuItem key={color} value={color}>
                {color}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {filterOptions.interiorColors.length > 1 && (
        <FormControl fullWidth size="small">
          <InputLabel>Interior Color</InputLabel>
          <Select
            name="interiorColor"
            value={filters.interiorColor}
            label="Interior Color"
            onChange={onFilterChange}
          >
            <MenuItem value="">Any</MenuItem>
            {filterOptions.interiorColors.map((color) => (
              <MenuItem key={color} value={color}>
                {color}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      <FormControl fullWidth size="small">
        <InputLabel>Certified</InputLabel>
        <Select
          name="isCertified"
          value={filters.isCertified}
          label="Certified"
          onChange={onFilterChange}
        >
          <MenuItem value="">Any</MenuItem>
          <MenuItem value="1">Certified</MenuItem>
          <MenuItem value="0">Non-Certified</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default CarFilters;
